//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import Formatters from '../../components/grid-addons/formatters';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { ImportedShopifyOrder } from '../../graphql/entities';
import { Direction, IImportedShopifyOrder } from '../../graphql/schema/p4types';
import { useImportedOrderWorkspaceActions } from '../../actions/sales/ImportedOrderWorkspaceAction';
import ImportShopifyOrderRetryMutation from '../../graphql/mutations/sales/ImportShopifyOrderRetryMutation.graphql';
import { WorkspaceActionButtons } from '../../components/Workspace/WorkspaceActionButtons';
import { Paths } from '../../@types/keyOfNested';
import { DispatchSource } from '../../components/ActionButtons/dispatch/DispatchModal';

const IMPORTED_SHOPIFY_ORDER_FIELD_NAMES: Array<Paths<IImportedShopifyOrder>> = [
  'createdAt',
  'shopifyConfiguration.name',
  'orderReference',
  'salesOrder.orderNumber',
  'orderImportFailureReason',
  'failureDescription',
  'shippedAt',
  'resolved',
];

const IMPORTED_SHOPIFY_ORDER_COLUMN_OVERRIDES = {
  orderImportFailureReason: {
    options: fieldMetaData.OrderImportFailureReason,
    formatter: Formatters.EnumFormatter,
  },
};

const ImportShopifyOrderWorkspaceActions = (props) => {
  const [actions, modals] = useImportedOrderWorkspaceActions({
    retryMutation: ImportShopifyOrderRetryMutation,
    type: 'importedShopifyOrders',
    dispatchSource: DispatchSource.ImportedShopifyOrderWorkspace,
  });

  return (
    <>
      {modals}
      <WorkspaceActionButtons {...props} actionButtons={actions} />
    </>
  );
};

const ImportedShopifyOrderWorkspace = (props) => {
  const workspaceProps = useWorkspace<IImportedShopifyOrder>(props, ImportedShopifyOrder, {
    columns: IMPORTED_SHOPIFY_ORDER_FIELD_NAMES,
    columnOverrides: IMPORTED_SHOPIFY_ORDER_COLUMN_OVERRIDES,
    initialSortColumn: 'createdAt',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={ImportedShopifyOrder.type}
      title={ImportedShopifyOrder.title}
      formUrl={ImportedShopifyOrder.formUrl}
      defaultQuery={ImportedShopifyOrder.workspace}
      entity={ImportedShopifyOrder}
      permittedOperations={ImportedShopifyOrder.operations}
      {...workspaceProps}
      {...props}
      workspaceActionButtonsHOC={ImportShopifyOrderWorkspaceActions}
    />
  );
};

export default ImportedShopifyOrderWorkspace;
